import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-progress-bar',
    standalone: true,
    templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
    public readonly hasError = input<boolean>(false);
    public readonly itemsLoaded = input.required<number>();
    public readonly total = input.required<number>();

    protected readonly progress = computed(() => {
        const total = Math.max(0, this.total() ?? 0);
        const itemsLoaded = Math.max(0, this.itemsLoaded() ?? 0);
        const percentage = total ? (itemsLoaded / total) * 100 : 0;

        return Math.min(100, Math.max(0, Math.round(percentage)));
    });
}
